import {
  Play,
  Pause,
  SkipBack,
  SkipForward,
  RotateCcw,
  Gauge,
} from "lucide-react";

const RATES = [0.1, 0.25, 0.5, 1, 1.5, 2];

export default function ControlBar({
  globalPlaying,
  onTogglePlay,
  onStepBack,
  onStepForward,
  onReset,
  rate,
  onRateChange,
  syncEnabled,
}) {
  return (
    <footer
      className="h-20 md:h-24 bg-[#0D0D0D] border-t border-white/10 flex items-center justify-between px-4 md:px-6 shrink-0 gap-3"
      data-testid="control-bar"
    >
      {/* Left: reset */}
      <div className="flex items-center gap-2">
        <button
          onClick={onReset}
          className="flex items-center gap-2 px-3 h-10 rounded-md border border-white/15 bg-white/[0.03] hover:bg-white/[0.08] transition-colors text-xs uppercase tracking-[0.15em] font-bold text-white/80 hover:text-white"
          data-testid="reset-button"
          title="Reset both to start (R)"
        >
          <RotateCcw className="w-4 h-4" />
          <span className="hidden md:inline">Reset</span>
        </button>
      </div>

      {/* Center: transport */}
      <div className="flex items-center gap-2 md:gap-3">
        <button
          onClick={onStepBack}
          className="w-11 h-11 rounded-md border border-white/15 bg-white/[0.03] hover:bg-white/[0.08] transition-all flex items-center justify-center text-white/80 hover:text-white active:scale-95"
          data-testid="step-back-button"
          title="Step back 1 frame (←)"
        >
          <SkipBack className="w-5 h-5" />
        </button>

        <button
          onClick={onTogglePlay}
          className="w-14 h-14 rounded-full bg-[#007AFF] hover:bg-[#3395FF] transition-all flex items-center justify-center shadow-[0_0_24px_rgba(0,122,255,0.35)] active:scale-95 relative"
          data-testid="global-play-button"
          title={globalPlaying ? "Pause (Space)" : "Play (Space)"}
        >
          {globalPlaying ? (
            <Pause className="w-6 h-6 text-white fill-white" />
          ) : (
            <Play className="w-6 h-6 text-white fill-white ml-1" />
          )}
          {syncEnabled && (
            <span className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-[#E4FF00] border-2 border-[#0D0D0D]" />
          )}
        </button>

        <button
          onClick={onStepForward}
          className="w-11 h-11 rounded-md border border-white/15 bg-white/[0.03] hover:bg-white/[0.08] transition-all flex items-center justify-center text-white/80 hover:text-white active:scale-95"
          data-testid="step-forward-button"
          title="Step forward 1 frame (→)"
        >
          <SkipForward className="w-5 h-5" />
        </button>
      </div>

      {/* Right: speed control */}
      <div
        className="flex items-center gap-2 bg-white/[0.03] border border-white/15 rounded-md px-2 h-10"
        data-testid="speed-control"
      >
        <Gauge className="w-4 h-4 text-white/50 hidden sm:block" />
        {RATES.map((r) => (
          <button
            key={r}
            onClick={() => onRateChange(r)}
            className={`px-2 md:px-2.5 h-8 rounded text-xs font-mono font-bold transition-all ${
              rate === r
                ? "bg-[#007AFF] text-white"
                : "text-white/60 hover:text-white hover:bg-white/5"
            }`}
            data-testid={`rate-${r}-button`}
          >
            {r}x
          </button>
        ))}
      </div>
    </footer>
  );
}
